export const SET_CABINETS = 'SET_CABINETS'
export const CREATE_CABINET = 'CREATE_CABINET'
export const EDIT_CABINET = 'EDIT_CABINET'
export const SET_CLIENTS_BY_OFFICEID = 'SET_CLIENTS_BY_OFFICEID'
export const SET_ADVISORS_BY_OFFICEID = 'SET_ADVISORS_BY_OFFICEID'
export const SET_ADMIN_BY_OFFICEID = 'SET_ADMIN_BY_OFFICEID'


// WEBPACK FOOTER //
// ./src/store/modules/Cabinets/types.js